/**
 * shiftCajaDemoMay12AnchorToLocalDay.ts — Ajusta fechas del preset demo al día calendario local.
 *
 * QUÉ HACE: El dataset canónico usa el ancla `2026-05-12` en ISO; al hidratar LS se
 * reemplaza ese prefijo por `YYYY-MM-DD` de hoy (zona local), conservando hora y sufijo.
 *
 * QUÉ INVOCA: Nada externo.
 * QUÉ NO DEBE HACER: Mutar el módulo de datos canónico; solo transforma copias.
 */

export const DEMO_CAJA_DATA_ANCHOR_DAY = "2026-05-12";

/** Día calendario local en formato `YYYY-MM-DD` (coincide con filtros de historial). */
export function localCalendarDayIso(): string {
  const n = new Date();
  return `${n.getFullYear()}-${String(n.getMonth() + 1).padStart(2, "0")}-${String(n.getDate()).padStart(2, "0")}`;
}

/** Si el string es ISO con prefijo ancla, sustituye solo la parte fecha. */
export function shiftAnchorDayInString(s: string, targetDay: string): string {
  if (!s.startsWith(DEMO_CAJA_DATA_ANCHOR_DAY)) return s;
  return targetDay + s.slice(DEMO_CAJA_DATA_ANCHOR_DAY.length);
}

/** Recorre JSON-like y aplica `shiftAnchorDayInString` a cada string. */
export function shiftCajaDemoAnchorDatesDeep<T>(
  value: T,
  targetDay: string,
): T {
  if (value === null || value === undefined) return value;
  if (typeof value === "string") {
    return shiftAnchorDayInString(value, targetDay) as T;
  }
  if (Array.isArray(value)) {
    return value.map((x) => shiftCajaDemoAnchorDatesDeep(x, targetDay)) as T;
  }
  if (typeof value === "object") {
    const o = value as Record<string, unknown>;
    const out: Record<string, unknown> = {};
    for (const k of Object.keys(o)) {
      out[k] = shiftCajaDemoAnchorDatesDeep(o[k], targetDay);
    }
    return out as T;
  }
  return value;
}
